<template>
  <div class="actions">
    <button type="button" class="btn btn-black" :disabled="gameDone == true" @click="this.$emit('verification')">
      Vérifier
    </button>
    <p class="link" @click="this.$emit('showResponse')">{{ seeResponseText }}</p>
  </div>
  <div class="message" v-if="message" v-html="message"></div>
</template>

<script>
export default {
  name: "ActionsGames",
  props: {
    message: String,
    gameDone: Boolean,
    seeResponseText: {
      type: String,
      default: "Voir la réponse"
    }
  },
  data: () => ({}),
};
</script>

<style lang="scss">
.actions {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;
  .link {
    color: grey;
    cursor: pointer;
    text-decoration: underline;
    font-size: 0.8rem;
    margin-left: 2rem;
    align-self: center;
  }
  .btn {
    cursor: pointer;
    padding: 1rem 3rem;
    border: none;
    &-black {
      background-color: #000;
      color: white;
      text-transform: uppercase;
    }
    &:disabled {
      opacity: 0.5;
    }
  }
}

.message {
  h2 {
    font-size: 2rem;
  }
}
</style>